import { overlay } from 'overlay-kit';
import { AchievementStandardSearchModal } from '../components/AchievementStandardSearchModal';
import { StandardPickerCategoryProvider } from '../context/StandardPickerCategoryProvider';
import type { AchievementStandardWithOrigin, CategoryContext } from '../types';

/**
 * 성취기준 검색 모달 열기 파라미터
 */
export interface OpenAchievementStandardSearchModalParams {
  /** 카테고리 컨텍스트 (학년/과목 초기값) */
  categoryContext?: CategoryContext;
  /** 텍스트 프롬프트 */
  textPrompt: string;
  /** 이미 선택된 성취기준들 */
  alreadySelectedStandards: AchievementStandardWithOrigin[];
}

/**
 * 성취기준 검색 모달을 엽니다.
 * overlay-kit을 사용하여 비동기로 모달을 표시합니다.
 *
 * @param params - 모달 파라미터
 * @returns 선택된 성취기준 배열 Promise
 *
 * @example
 * const selected = await openAchievementStandardSearchModal({
 *   categoryContext: {
 *     schoolInfoTree,
 *     subjectTree,
 *     initialSchoolInfoId: '10101',
 *     initialSubjectId: 'math',
 *   },
 *   textPrompt: '분수의 덧셈',
 *   alreadySelectedStandards: [],
 * });
 */
export function openAchievementStandardSearchModal(params: OpenAchievementStandardSearchModalParams): Promise<AchievementStandardWithOrigin[]> {
  // Provide default empty values if categoryContext is not provided
  const categoryContext: CategoryContext = params.categoryContext || {
    schoolInfoTree: {
      categoryTreeId: '',
      categoryGroupId: '',
      type: 'SCHOOL_TYPE',
      name: '',
      order: 0,
      children: [],
      ancestors: []
    },
    subjectTree: [],
    initialSchoolInfoId: undefined,
    initialSubjectId: undefined
  };
  return overlay.openAsync<AchievementStandardWithOrigin[]>(({
    close,
    unmount
  }) => <StandardPickerCategoryProvider value={categoryContext}>
        <AchievementStandardSearchModal onClose={() => {
      unmount();
    }} onConfirm={selectedStandards => {
      close(selectedStandards);
      unmount();
    }} textPrompt={params.textPrompt} alreadySelectedAchievementStandards={params.alreadySelectedStandards} />
      </StandardPickerCategoryProvider>);
}